import { graphql, useStaticQuery } from 'gatsby';

export default function useWeeklySabha() {
  const { markdownRemark } = useStaticQuery(
    graphql`
      {
        markdownRemark(frontmatter: { slug: { eq: "Weekly Youth Sabha" } }) {
          frontmatter {
            date
            title
            src {
              childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH)
              }
            }
          }
        }
      }
    `
  );
  return markdownRemark.frontmatter;
}
